import React, { useEffect, useMemo, useState } from 'react';
import { Container } from '../../../../common/components/container';
import { TopNavigationBar } from '../../../../common/components/navigation-bar';
import { useTranslation } from 'react-i18next';
import { LearningCourseStatistics, useCourseStatisticsExporter } from '../course/statistics';
import Spinner from '../../../../common/components/spinner';
import { useHistory, useRouteMatch } from 'react-router';
import Api from '../../../../common/services/api';
import { useSelector } from 'react-redux';
import { selected } from '@modules/organisation/selectors/organisation';
import Placeholder from '../../../../common/components/placeholder';

const AcademyStatisticsContainer = () => {
    const orgId = useSelector(selected)?.id;
  // console.log("debug orgId", orgId);

  const [filter, setFilter] = useState(null);
  const [course, setCourse] = useState<any>(null);
  const [courses, setCourses] = useState<any>(null);
  const [query, setQuery] = useState();

  const routeParams: any = useRouteMatch()?.params;
  const networkId = routeParams?.networkId;
  // console.log("debug networkId", networkId);
  useEffect(() => {
    const url = networkId ?
      `/v2/networks/${networkId}/courses?type=academy` :
      `/v2/organisations/${orgId}/courses?type=academy`;
    Api.get(url).then((response: any) => {
      // console.log("debug response", response);
      if (response.data[0]) {
        setCourse(response.data[0]);
      }
      setCourses(response.data);
    });
  }, [networkId, orgId, setCourses, setCourse]);

  const [statistics, setStatistics] = useState<any>(null);
  useEffect(() => {
    if (course) {
      const url = networkId ?
        `/v2/networks/${networkId}/courses/${course.id}/statistics` :
        `/v2/organisations/${orgId}/courses/${course.id}/statistics`;
      Api.get(url).then((stats: any) => {
        setStatistics(stats);
      });
    }
  }, [networkId, orgId, course, setStatistics]);

  const tableConfig = useMemo(() => {
    return {
      useCursor: true,
      onFetch: (nextCursor: any, filters: any, limit = 10) => {
        const queryString = Api.utils.toQuery({
          cursor: nextCursor,
          limit,
          q: filters.q,
          filter: filters.filter
        });

        const urlBase = filters.networkId
          ? `/v2/networks/${filters.networkId}`
          : `/v2/organisations/${filters.orgId}`;

        return Api.get(
          `${urlBase}/courses/${filters.courseId}/statistics/userprogress?${queryString}`
        );
      },
      filter: {
        q: query,
        filter,
        courseId: course?.id,
        networkId,
        orgId
      },
    };
  }, [networkId, course, filter, query, orgId]);

  const history = useHistory();

  const downloadFile = useCourseStatisticsExporter(
    networkId,
    orgId,
    course?.id,
    filter
  );

  const { t } = useTranslation();


  if (!courses) {
    return <Spinner className="elearningSpinner" size="large" centered />;
  }

  return (
    <Container name="Academy Statistics">
      <TopNavigationBar
        title={t('learning:breadcrumb_academy')}
        learnMoreHref={t('learning:academy_learn_more')}
      />
      <Container.Content>
        {courses.length > 0 ? (
          <LearningCourseStatistics
            // @ts-expect-error
            selectOptions={courses}
            selectFilter={course}
            setSelectFilter={setCourse}
            filter={filter}
            setFilter={setFilter}
            setQuery={setQuery}
            tableConfig={tableConfig}
            history={history}
            query={query}
            courseHasDeadline={
              !!(
                course?.settings?.deadline ||
                course?.settings?.deadline_after_days_invited
              )
            }
            downloadFile={downloadFile}
            statistics={statistics}
            networkId={networkId}
          />
        ) : (
          <Placeholder title={t('common:select_no_results')} />
        )}
      </Container.Content>
    </Container>
  );
};

export default AcademyStatisticsContainer;
